import { render, staticRenderFns } from "./UeDetailDialog.vue?vue&type=template&id=37159dad&"
import script from "./UeDetailDialog.vue?vue&type=script&lang=js&"
export * from "./UeDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports